/**
 * The app navigator (formerly "AppNavigator" and "MainNavigator") is used for the primary
 * navigation flows of your app.
 * Generally speaking, it will contain an auth flow (registration, login, forgot password)
 * and a "main" flow which the user will use once logged in.
 */
import {
  DarkTheme,
  DefaultTheme,
  NavigationContainer,
} from "@react-navigation/native"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import { StackScreenProps } from "@react-navigation/stack"
import { observer } from "mobx-react-lite"
import React from "react"
import { Platform, useColorScheme } from "react-native"
import Config from "../config"
import { customApp } from "../config";
import * as Storage from "../utils/storage"

import { useStores } from "../models"
import {
  HomeScreen, LoginScreen,
} from "../screens"
import { navigationRef, useBackButtonHandler } from "./navigationUtilities"
import { Box, HStack, Icon, IconButton, ScrollView, Spinner, StatusBar, Text, VStack , Button} from "native-base"
import { MaterialIcons, Ionicons, MaterialCommunityIcons, FontAwesome5 } from "@expo/vector-icons";
import Spacer from "../components/base/Spacer"
import { initBackgroundSync } from "../utils/workManager"
export type AppStackParamList = {
  Login: undefined,
  Home: undefined,
}

/**
 * This is a list of all the route names that will exit the app if the back button
 * is pressed while in that screen. Only affects Android.
 */
//const exitRoutes = Config.exitRoutes

export type AppStackScreenProps<T extends keyof AppStackParamList> = StackScreenProps<AppStackParamList, T>

const Stack = createNativeStackNavigator<AppStackParamList>()

interface NavigationProps extends Partial<React.ComponentProps<typeof NavigationContainer>> { }

const RescueSpinner = ({ onReset }: { onReset: () => void }) => {
  const [showRescue, setShowRescue] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowRescue(true);
    }, 6000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <VStack flex={1} justifyContent="center" alignItems="center" p={4} bg="gray.100">
      <Spinner size="lg" color="primary.500" />
      {showRescue && (
        <VStack mt={6} space={3} alignItems="center" maxW="320px">
          <Text fontSize="sm" color="gray.600" textAlign="center">
            ¿La aplicación tarda en responder?
          </Text>
          <Button
            size="sm"
            variant="subtle"
            colorScheme="danger"
            onPress={async () => {
              await Storage.clearSessionAndNavigation();
              if (Platform.OS === "web" && typeof window !== "undefined") {
                window.location.href = "/";
              } else {
                onReset();
              }
            }}
          >
            Restablecer inicio (conservar datos)
          </Button>
        </VStack>
      )}
    </VStack>
  );
};

export const AppNavigator = observer(function AppNavigator(props: NavigationProps) {
  const colorScheme = useColorScheme()
  const { authenticationStore, formsStore,statusStore,itemsStore } = useStores();
  const [realoadMe,setReloadMe] = React.useState(false);
  console.log("fromBuilder")
  if(Platform.OS == "web" &&  window.localStorage.fromBuilder){
   
    if(window.localStorage.fromBuilder!=""){
      console.log("fromBuilder")
      setTimeout(async () => {
        const fromBuilder = JSON.parse(atob(window.localStorage.fromBuilder));
        Storage.removeLocal("HOME_NAVIGATION_STATE");
        Storage.removeItem("v3-HOME_NAVIGATION_STATE")
        authenticationStore.signSAML(fromBuilder); 
        window.localStorage.removeItem("fromBuilder");
        localStorage.setItem("loggedFromBuilder","true");
        setTimeout(()=>setReloadMe(true),2500);
      }
      ,100);      
      return <RescueSpinner onReset={() => setReloadMe(prev => !prev)} />;
    }
  }
  if (authenticationStore.userIdLogged == "") {
    if (customApp.user && customApp.user != "") {
      setTimeout(() => authenticationStore.signIn({ username: customApp.user, password: customApp.pass }), 500);
      return <RescueSpinner onReset={() => setReloadMe(prev => !prev)} />;
    }
    return <LoginScreen />

  } else {
    const user = authenticationStore.userInfo.user;
    initBackgroundSync(authenticationStore, itemsStore);
    const subscriptions = JSON.parse(JSON.stringify(formsStore.mySubscriptions().subscriptions));
    if (subscriptions.length > 0)
      return <HomeScreen />
    return <>
    <StatusBar backgroundColor={"#3700B3"} barStyle="light-content" />
    <Box safeAreaTop bg="primary.400" />
    <HStack bg="primary.400" px="0" py="0" justifyContent="space-between" alignItems="center" w="100%">
      <HStack alignItems="center" w="100%">
        <VStack>
          <Text color="white" fontSize="18" m="2" >
            {customApp.displayName}
          </Text>          
        </VStack>
        <Spacer/>
        <IconButton variant={"ghost"} color={"white"} onPress={async () => {  await itemsStore.upload({}); formsStore.getSubscriptions();}}
            icon={<Icon as={MaterialCommunityIcons} name="cloud-sync-outline" size="xl" color={"white"}/>}
          />    
      </HStack>
      </HStack>       
      <ScrollView backgroundColor={"gray.200"} contentContainerStyle={{ flexGrow: 1, justifyContent: 'center' }}>
        <VStack alignItems="center" justifyContent="center" p="4" >
          <Icon as={MaterialCommunityIcons} name="clipboard-text-off-outline" size="6xl" color="gray.400" mb="4" />
          <Text bold fontSize={"lg"} textAlign="center">No tienes Formularios asignados</Text>
          <Text marginTop="2" mx="2" textAlign="center">Debes solicitarle a tu administrador de acceso a la plataforma que te asigne formularios para poder trabajar en la aplicación</Text>
          <Button marginTop="10"  variant={"solid"} colorScheme={"secondary"} width={"full"} onPress={async () => {  await itemsStore.upload({}); formsStore.getSubscriptions();}}>
            SINCRONIZAR AHORA
            </Button>
        </VStack>
      </ScrollView>
      <HStack alignItems={"center"} backgroundColor={"light.100"} >
        <IconButton variant={"light"}
          size="md"
          colorScheme="danger" onPress={authenticationStore.signOut}
          icon={<Icon as={MaterialIcons} name="logout" />}
        />
        <Text>{user?.firstName} {user?.lastName}</Text>
      </HStack>
    </>;
  }

})
